import smartlookClient from 'smartlook-client';

import type { Workspace } from '@/entities/workspace/workspace-types';
import type { User } from '../../entities/user/user-types';

export const initSmartlook = (user: User, workspace: Workspace) => {
  smartlookClient.init(import.meta.env.VITE_PUBLIC_SMARTLOOK_API_KEY as string, {
    region: 'us',
  });
  smartlookIdentifyUser(user, workspace);
};

export const smartlookIdentifyUser = (user: User, workspace: Workspace) => {
  smartlookClient.identify(user.email, {
    email: user.email,
    role: workspace.privilege,
    plan: workspace.plan,
    workspace_id: workspace.id,
    workspace_name: workspace.name,
  });
};
